import React from 'react';

function TimorLeste(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_123980)">
        <mask
          id="mask0_800_123980"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_123980)">
          <path
            d="M0 -1H-1V0V24V25H0H36H37V24V0V-1H36H0Z"
            fill="#E31D1C"
            stroke="#F7FCFF"
            strokeWidth="2"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0L27 12L0 24V0Z"
            fill="#FECA00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0L18 12L0 24V0Z"
            fill="#272727"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.47897 14.4086L5.20701 16.5086L4.96967 13.5232L2.07227 11.9366L5.09389 11.0938L5.58804 8.13567L7.67995 10.4779L10.731 9.75122L9.15402 12.5266L10.6875 15.2033L7.47897 14.4086Z"
            fill="#F7FCFF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_123980">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default TimorLeste;
